<ngx-spinner bdColor="rgba(0,0,0,0.3)" size="medium" color="#0DB4E8" type="ball-clip-rotate"></ngx-spinner>

<div class="expense-summary" *ngIf="!loading">

  <!-- Error state -->
  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <ng-container *ngIf="summary">

    <!-- Header -->
    <div class="summary-header d-flex align-items-center justify-content-between mb-4">
      <div>
        <h4 class="mb-0">Resumen de Gastos</h4>
        <small class="text-muted">Folio: <strong>{{ summary.folio }}</strong> &mdash; {{ summary.client }}</small>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary btn-sm" (click)="downloadPdf()">
          <i class="ti ti-download me-1"></i>Descargar PDF
        </button>
        <button class="btn btn-outline-primary btn-sm" (click)="goBack()">
          <i class="ti ti-arrow-left me-1"></i>Volver
        </button>
      </div>
    </div>

    <!-- Service Info -->
    <div class="card mb-4">
      <div class="card-body py-3">
        <div class="row g-3 text-sm">
          <div class="col-6 col-md-3">
            <span class="text-muted d-block">Operador</span>
            <strong>{{ summary.driver }}</strong>
          </div>
          <div class="col-6 col-md-3">
            <span class="text-muted d-block">Unidad / Placas</span>
            <strong>{{ summary.unit }} &mdash; {{ summary.plates }}</strong>
          </div>
          <div class="col-6 col-md-3">
            <span class="text-muted d-block">Fecha carga</span>
            <strong>{{ summary.load_date | date:'dd/MM/yyyy' }}</strong>
          </div>
          <div class="col-6 col-md-3">
            <span class="text-muted d-block">Fecha descarga</span>
            <strong>{{ summary.unload_date | date:'dd/MM/yyyy' }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4">

      <!-- Left: sections -->
      <div class="col-lg-8">

        <!-- Combustible -->
        <div class="card expense-card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center category-fuel" (click)="toggle('fuel')" style="cursor:pointer">
            <span><i class="ti ti-gas-station me-2"></i>Combustible</span>
            <span class="d-flex align-items-center gap-3">
              <strong>{{ formatCurrency(summary.total_fuel) }}</strong>
              <i class="ti" [ngClass]="collapsed['fuel'] ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
            </span>
          </div>
          <div class="card-body p-0" *ngIf="!collapsed['fuel']">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead><tr><th>Km</th><th>Litros</th><th>Monto</th><th>Método pago</th><th>Comprobante</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of summary.fuel_expenses">
                    <td>{{ item.mileage }}</td>
                    <td>{{ item.liters }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                    <td>{{ item.payment_method || '—' }}</td>
                    <td>
                      <a *ngIf="item.evidence" [href]="item.evidence" target="_blank" class="btn btn-link btn-sm p-0">Ver</a>
                      <span *ngIf="!item.evidence" class="text-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!summary.fuel_expenses.length"><td colspan="5" class="text-center text-muted">Sin registros</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Casetas -->
        <div class="card expense-card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center category-toll" (click)="toggle('tolls')" style="cursor:pointer">
            <span><i class="ti ti-road me-2"></i>Casetas</span>
            <span class="d-flex align-items-center gap-3">
              <strong>{{ formatCurrency(summary.total_tolls) }}</strong>
              <i class="ti" [ngClass]="collapsed['tolls'] ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
            </span>
          </div>
          <div class="card-body p-0" *ngIf="!collapsed['tolls']">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead><tr><th>Caseta</th><th>Tramo</th><th>Monto</th><th>Método pago</th><th>Comprobante</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of summary.toll_expenses">
                    <td>{{ item.toll_booth || '—' }}</td>
                    <td>{{ item.segment || '—' }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                    <td>{{ item.payment_method || '—' }}</td>
                    <td>
                      <a *ngIf="item.evidence" [href]="item.evidence" target="_blank" class="btn btn-link btn-sm p-0">Ver</a>
                      <span *ngIf="!item.evidence" class="text-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!summary.toll_expenses.length"><td colspan="5" class="text-center text-muted">Sin registros</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Alojamiento -->
        <div class="card expense-card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center category-accommodation" (click)="toggle('accommodation')" style="cursor:pointer">
            <span><i class="ti ti-bed me-2"></i>Alojamiento</span>
            <span class="d-flex align-items-center gap-3">
              <strong>{{ formatCurrency(summary.total_accommodation) }}</strong>
              <i class="ti" [ngClass]="collapsed['accommodation'] ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
            </span>
          </div>
          <div class="card-body p-0" *ngIf="!collapsed['accommodation']">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead><tr><th>Noches</th><th>Monto</th><th>Método pago</th><th>Comprobante</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of summary.accommodation_expenses">
                    <td>{{ item.stay_duration }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                    <td>{{ item.payment_method || '—' }}</td>
                    <td>
                      <a *ngIf="item.evidence" [href]="item.evidence" target="_blank" class="btn btn-link btn-sm p-0">Ver</a>
                      <span *ngIf="!item.evidence" class="text-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!summary.accommodation_expenses.length"><td colspan="4" class="text-center text-muted">Sin registros</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Multas -->
        <div class="card expense-card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center category-fine" (click)="toggle('fines')" style="cursor:pointer">
            <span><i class="ti ti-alert-triangle me-2"></i>Multas</span>
            <span class="d-flex align-items-center gap-3">
              <strong>{{ formatCurrency(summary.total_fines) }}</strong>
              <i class="ti" [ngClass]="collapsed['fines'] ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
            </span>
          </div>
          <div class="card-body p-0" *ngIf="!collapsed['fines']">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead><tr><th>Tipo</th><th>Monto</th><th>Justificación</th><th>Comprobante</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of summary.traffic_fine_expenses">
                    <td>{{ item.fine_type || '—' }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                    <td>{{ item.justification }}</td>
                    <td>
                      <a *ngIf="item.evidence" [href]="item.evidence" target="_blank" class="btn btn-link btn-sm p-0">Ver</a>
                      <span *ngIf="!item.evidence" class="text-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!summary.traffic_fine_expenses.length"><td colspan="4" class="text-center text-muted">Sin registros</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Alimentos -->
        <div class="card expense-card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center category-food" (click)="toggle('food')" style="cursor:pointer">
            <span><i class="ti ti-tools-kitchen-2 me-2"></i>Alimentos</span>
            <span class="d-flex align-items-center gap-3">
              <strong>{{ formatCurrency(summary.total_food) }}</strong>
              <i class="ti" [ngClass]="collapsed['food'] ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
            </span>
          </div>
          <div class="card-body p-0" *ngIf="!collapsed['food']">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead><tr><th>Descripción</th><th>Monto</th><th>Método pago</th><th>Comprobante</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of summary.food_expenses">
                    <td>{{ item.description }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                    <td>{{ item.payment_method || '—' }}</td>
                    <td>
                      <a *ngIf="item.evidence" [href]="item.evidence" target="_blank" class="btn btn-link btn-sm p-0">Ver</a>
                      <span *ngIf="!item.evidence" class="text-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!summary.food_expenses.length"><td colspan="4" class="text-center text-muted">Sin registros</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Otros -->
        <div class="card expense-card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center category-other" (click)="toggle('other')" style="cursor:pointer">
            <span><i class="ti ti-dots me-2"></i>Otros</span>
            <span class="d-flex align-items-center gap-3">
              <strong>{{ formatCurrency(summary.total_other) }}</strong>
              <i class="ti" [ngClass]="collapsed['other'] ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
            </span>
          </div>
          <div class="card-body p-0" *ngIf="!collapsed['other']">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead><tr><th>Descripción</th><th>Monto</th><th>Método pago</th><th>Comprobante</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of summary.other_expenses">
                    <td>{{ item.description }}</td>
                    <td>{{ formatCurrency(item.amount) }}</td>
                    <td>{{ item.payment_method || '—' }}</td>
                    <td>
                      <a *ngIf="item.evidence" [href]="item.evidence" target="_blank" class="btn btn-link btn-sm p-0">Ver</a>
                      <span *ngIf="!item.evidence" class="text-muted">—</span>
                    </td>
                  </tr>
                  <tr *ngIf="!summary.other_expenses.length"><td colspan="4" class="text-center text-muted">Sin registros</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <!-- Right: chart + totals -->
      <div class="col-lg-4">

        <!-- Pie chart -->
        <div class="card mb-4">
          <div class="card-header"><strong>Distribución de gastos</strong></div>
          <div class="card-body d-flex justify-content-center">
            <canvas #pieChart style="max-height:260px"></canvas>
          </div>
        </div>

        <!-- Totals -->
        <div class="card">
          <div class="card-header"><strong>Resumen financiero</strong></div>
          <div class="card-body">
            <div class="d-flex justify-content-between mb-2">
              <span class="text-muted">Depósito inicial</span>
              <strong>{{ formatCurrency(summary.initial_deposit) }}</strong>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-muted">Total gastos</span>
              <strong>{{ formatCurrency(summary.total_expenses) }}</strong>
            </div>
            <hr />
            <div class="d-flex justify-content-between">
              <span class="fw-bold">Diferencia</span>
              <strong [ngClass]="balanceClass" style="font-size:1.2rem">{{ formatCurrency(balance) }}</strong>
            </div>
            <div class="mt-3 p-2 rounded text-center" [ngClass]="balance >= 0 ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'">
              {{ balance >= 0 ? 'Devolución al conductor: ' + formatCurrency(balance) : 'Cobro al conductor: ' + formatCurrency(balance * -1) }}
            </div>
          </div>
        </div>

      </div>
    </div>

  </ng-container>
</div>
